import { assoc, updateIn, filter } from 'icepick';
import type { RuleSetId } from '../../../model';
import { DELETE_SUCCESS, type DeleteSuccessAction } from '../../actions/rule/delete';
import {
	SAVE_RUN_AS_USER_SUCCESS,
	type SaveRunAsUserSuccessAction,
} from '../../actions/run-as-user';
import type { PersistedResultState } from './types';

type Actions = DeleteSuccessAction | SaveRunAsUserSuccessAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: PersistedResultState, action: Actions) => {
	switch (action.type) {
		case DELETE_SUCCESS: {
			const { deletedRuleSetId } = action.payload;

			return updateIn(state, ['ruleSets'], (ruleSets) =>
				// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
				filter((ruleSetId: RuleSetId) => ruleSetId !== deletedRuleSetId, ruleSets || []),
			);
		}
		case SAVE_RUN_AS_USER_SUCCESS: {
			const { runAsUserSettings } = action.payload;
			return assoc(state, 'projectRunAsUserSettings', runAsUserSettings);
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state || null;
		}
	}
};
